import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}



const divs = document.querySelectorAll('.cart-items-component'); // Select all matching divs

divs.forEach(function(div) { 
  div.addEventListener('scroll', function() {
    const scrollPercent = (div.scrollTop / div.scrollHeight) * 100;

    if (scrollPercent === 0) {
      div.classList.add('price-at-top');
      div.classList.remove('scrolled-5');
      console.log('At 0%: added price-at-top, removed scrolled-5');
    } 
    else if (scrollPercent > 20 && scrollPercent <= 40) {
      div.classList.add('scrolled-5');
      div.classList.remove('price-at-top');
      console.log('Between 5% and 30%: added scrolled-5 and price-at-top');
    } 
    else if (scrollPercent > 0 && scrollPercent <= 5) {
      div.classList.add('price-at-top');
      div.classList.remove('scrolled-5');
      console.log('Between 0% and 5%: added price-at-top, removed scrolled-5');
    }
    else {
      // Beyond 30%, remove both classes
      div.classList.remove('price-at-top');
      div.classList.remove('scrolled-5');
      div.classList.remove('sticky-net-payable');
      console.log('Scrolled beyond 30%: removed both classes');
    }
  });
});


 




